import React from 'react';
export function StatsBanner() {
  return <section className="w-full bg-white px-4 md:px-8 pb-16" data-id="element-311">
      <div className="max-w-[700px] mx-auto" data-id="element-312">
        <div className="rounded-2xl px-8 py-8 md:px-12 md:py-10 text-center bg-white" style={{
        border: '2px solid #e6a817'
      }} data-id="element-313">
          <p className="font-['Playfair_Display',_serif] text-[#4caf50] text-4xl md:text-5xl font-bold mb-2" data-id="element-314">
            +37.893
          </p>
          <p className="font-['Playfair_Display',_serif] text-[#1a1a1a] text-lg md:text-xl font-bold" data-id="element-315">
            mujeres ya tienen su independencia económica
          </p>
          <p className="font-['Playfair_Display',_serif] text-[#555] text-base md:text-lg mb-4" data-id="element-316">
            cocinando desde casa.
          </p>
          <div className="flex justify-center gap-1 text-2xl mb-2" data-id="element-317">
            <span data-id="element-318">⭐</span>
            <span data-id="element-319">⭐</span>
            <span data-id="element-320">⭐</span>
            <span data-id="element-321">⭐</span>
            <span className="opacity-40" data-id="element-322">⭐</span>
          </div>
          <p className="font-['Playfair_Display',_serif] text-[#1a1a1a] text-base md:text-lg font-semibold" data-id="element-323">
            Calificación Promedio: 4,9/5
          </p>
        </div>
      </div>
    </section>;
}